import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import SelectColumn from './table/SelectColumn'

class Fornitori extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('ragsoc').withType('text'),
      new Column('indiri').withType('text'),
      new Column('cap').withType('text').withIsVisible(false),
      new Column('locali').withType('text').withIsVisible(false),
      new Column('provi').withType('text'),
      new Column('telefo').withType('tel'),
      new Column('fax').withType('tel').withIsVisible(false),
      new Column('codfis').withType('text'),
      new Column('pariva').withType('text'),
      new Column('prodotti').withType('text'),
      new SelectColumn('referenziamento', Mapper.select.referenziamento()).withOptions([{ value: 'N', label: 'Non richiesto' }, { value: 'I', label: 'In attesa' }, { value: 'R', label: 'Ricevuto' }]).withType('text')
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ragsoc: { required: true, type: 'string' },
      indiri: { required: true, type: 'string' },
      cap: { required: true, type: 'string' },
      locali: { required: true, type: 'string' },
      provi: { required: true, type: 'string' },
      telefo: { required: true, type: 'string' }
    }
  }
}

export default new Fornitori()
